module.exports = __webpack_public_path__ + "img/jeanluc.5a82546b.png";